export default v => v === Infinity || isNaN(v)



// WEBPACK FOOTER //
// ./src/helpers/presentation/checkForInfinityOrNaN.js